import { Component, Input } from '@angular/core';
import { OsUpdateStatus, OsUpdateStatusState } from '@era/osupdates-sdk';
import { DeviceOsUpdateActionBarContainerComponent } from '../device-os-update-action-bar/device-os-update-action-bar.container';

@Component({
  selector: 'era-device-os-update-status-ui',
  templateUrl: './device-os-update-status.component.html',
  styleUrls: ['./device-os-update-status.component.scss'],
  imports: [DeviceOsUpdateActionBarContainerComponent],
})
export class DeviceOsUpdateStatusComponent {
  osUpdateStatusState = OsUpdateStatusState;
  @Input() osUpdateStatus: OsUpdateStatus;
}
